// Sitemap.jsx
import React, { useEffect, useState } from "react";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  TextField,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Alert,
  Snackbar,
  CircularProgress,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import RefreshIcon from "@mui/icons-material/Refresh";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  uploadSitemap,
  getAllSiteMappings,
  updateSiteMapping,
  deleteSiteMapping,
  getSitemapContent,
  getParentSitemapContent,
  updatePrentSiteMapping,
} from "../auth/service";
import "./sitemap.css";
import { useNavigate } from "react-router-dom";

const Sitemap = () => {
  const navigate = useNavigate();
  const [sitemaps, setSitemaps] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openUploadDialog, setOpenUploadDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedSitemap, setSelectedSitemap] = useState(null);
  const [editContent, setEditContent] = useState("");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  // Load sitemaps from API on component mount
  useEffect(() => {
    loadSitemaps();
  }, []);

  const loadSitemaps = async () => {
    setLoading(true);
    const response = await getAllSiteMappings();

    if (response.error) {
      showSnackbar(response.error, "error");
      setSitemaps([]);
    } else if (response.data && Array.isArray(response.data)) {
      setSitemaps(response.data);
    } else {
      setSitemaps([]);
    }
    setLoading(false);
  };

  const handleViewChildren = (sitemap) => {
    navigate(`/sitemaps/child?sitemap=${encodeURIComponent(sitemap.sourceSitemap)}`, {
      state: { sourceFile: sitemap.sourceFile },
    });
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file && (file.name.endsWith(".xml") || file.name.endsWith(".xml.gz"))) {
      setSelectedFile(file);
    } else {
      showSnackbar("Please upload a valid XML file", "error");
    }
  };

  const handleUploadSubmit = async () => {
    if (!selectedFile) {
      showSnackbar("Please select a file first", "error");
      return;
    }

    setLoading(true);
    const response = await uploadSitemap(selectedFile);

    if (response.error) {
      showSnackbar(response.error, "error");
    } else {
      showSnackbar("Sitemap uploaded successfully!", "success");
      setOpenUploadDialog(false);
      setSelectedFile(null);
      await loadSitemaps();
    }
    setLoading(false);
  };

  const handleEdit = async (sitemap) => {
    setSelectedSitemap(sitemap);
    const response = await getParentSitemapContent(sitemap._id);

    if (response.xmlContent) {
      setEditContent(response.xmlContent);
    } else {
      const xmlContent = constructXMLFromSitemap(sitemap);
      setEditContent(xmlContent);
    }

    setOpenEditDialog(true);
  };

  const handleDeleteClick = (sitemap) => {
    setSelectedSitemap(sitemap);
    setOpenDeleteDialog(true);
  };

  const handleConfirmDelete = async () => {
    setOpenDeleteDialog(false);
    setLoading(true);
    console.log(selectedSitemap, "selectedChild")

    const response = await deleteSiteMapping(selectedSitemap._id);

    if (response.error) {
      showSnackbar(response.error, "error");
    } else {
      showSnackbar("Sitemap deleted successfully!", "success");
      await loadSitemaps();
    }
    setLoading(false);
    setSelectedSitemap(null);
  };

  // const constructXMLFromSitemap = (sitemap) => {
  //   let xml = '<?xml version="1.0" encoding="UTF-8"?>\n';
  //   xml += '<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">\n';
  //   xml += "  <url>\n";
  //   xml += `    <loc>${sitemap.loc || ""}</loc>\n`;
  //   if (sitemap.lastmod) xml += `    <lastmod>${sitemap.lastmod}</lastmod>\n`;
  //   if (sitemap.changefreq)
  //     xml += `    <changefreq>${sitemap.changefreq}</changefreq>\n`;
  //   if (sitemap.priority)
  //     xml += `    <priority>${sitemap.priority}</priority>\n`;
  //   xml += "  </url>\n";
  //   xml += "</urlset>";
  //   return xml;
  // };

  const constructXMLFromSitemap = (sitemap) => {
    let xml = '<?xml version="1.0" encoding="UTF-8"?>\n';
    xml += '<sitemapindex xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">\n';
    xml += "  <sitemap>\n";
    xml += `    <loc>${sitemap.sourceSitemap || sitemap.loc || ""}</loc>\n`;
    if (sitemap.sourceSitemapLastmod || sitemap.lastmod)
      xml += `    <lastmod>${sitemap.sourceSitemapLastmod || sitemap.lastmod}</lastmod>\n`;
    xml += "  </sitemap>\n";
    xml += "</sitemapindex>";
    return xml;
  };

  // const parseXMLToUpdateData = (xmlContent) => {
  //   const parser = new DOMParser();
  //   const xmlDoc = parser.parseFromString(xmlContent, "text/xml");

  //   const parserError = xmlDoc.getElementsByTagName("parsererror");
  //   if (parserError.length > 0) {
  //     throw new Error("Invalid XML format");
  //   }

  //   const url = xmlDoc.getElementsByTagName("url")[0];
  //   if (!url) {
  //     throw new Error("No URL found in XML");
  //   }

  //   const loc = url.getElementsByTagName("loc")[0]?.textContent || "";
  //   const changefreq =
  //     url.getElementsByTagName("changefreq")[0]?.textContent || "";
  //   const lastmod = url.getElementsByTagName("lastmod")[0]?.textContent || "";
  //   const priority = url.getElementsByTagName("priority")[0]?.textContent || "";

  //   return {
  //     loc,
  //     changefreq,
  //     lastmod,
  //     priority,
  //     updatedAt: new Date().toISOString(),
  //   };
  // };

  const parseXMLToUpdateData = (xmlContent) => {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlContent, "text/xml");

    const parserError = xmlDoc.getElementsByTagName("parsererror");
    if (parserError.length > 0) {
      throw new Error("Invalid XML format");
    }

    const sitemapEntry =
      xmlDoc.getElementsByTagName("sitemap")[0] ||
      xmlDoc.getElementsByTagName("url")[0];

    if (!sitemapEntry) {
      throw new Error("No sitemap or URL entry found in XML");
    }

    const loc = sitemapEntry.getElementsByTagName("loc")[0]?.textContent || "";
    const lastmod =
      sitemapEntry.getElementsByTagName("lastmod")[0]?.textContent || "";

    return {
      newSitemap: loc,           // ✅ required body field
      lastmod,
    };
  };

  // const handleUpdateSitemap = async () => {
  //   if (!editContent.trim()) {
  //     showSnackbar("Sitemap content cannot be empty", "error");
  //     return;
  //   }

  //   setLoading(true);
  //   try {
  //     const updateData = parseXMLToUpdateData(editContent);
  //     const response = await updatePrentSiteMapping(selectedSitemap._id, updateData);

  //     if (response.error) {
  //       showSnackbar(response.error, "error");
  //     } else {
  //       showSnackbar("Sitemap updated successfully!", "success");
  //       setOpenEditDialog(false);
  //       setSelectedSitemap(null);
  //       setEditContent("");
  //       await loadSitemaps();
  //     }
  //   } catch (error) {
  //     showSnackbar(error.message || "Error updating sitemap", "error");
  //   }
  //   setLoading(false);
  // };

  const handleUpdateSitemap = async () => {
    if (!editContent.trim()) {
      showSnackbar("Sitemap content cannot be empty", "error");
      return;
    }

    setLoading(true);
    try {
      const updateData = parseXMLToUpdateData(editContent);

      // sitemap param = existing sourceSitemap URL, body = { newSitemap, lastmod }
      const response = await updatePrentSiteMapping(
        selectedSitemap.sourceSitemap,  // ✅ used as ?sitemap= query param
        updateData                       // ✅ { newSitemap, lastmod } as body
      );

      if (response.error) {
        showSnackbar(response.error, "error");
      } else {
        showSnackbar("Sitemap updated successfully!", "success");
        setOpenEditDialog(false);
        setSelectedSitemap(null);
        setEditContent("");
        await loadSitemaps();
      }
    } catch (error) {
      showSnackbar(error.message || "Error updating sitemap", "error");
    }
    setLoading(false);
  };

  const showSnackbar = (message, severity) => {
    setSnackbar({
      open: true,
      message,
      severity,
    });
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleString();
  };

  return (
    <div className="sitemap-container">
      <div className="sitemap-header-container">
        <span className="sitemap-header">Sitemap Manager</span>
        <div className="btn-container">
          <Button
            variant="outlined"
            onClick={loadSitemaps}
            startIcon={<RefreshIcon />}
            disabled={loading}
          >
            Refresh
          </Button>
          <Button
            variant="contained"
            className="bordered-button"
            onClick={() => setOpenUploadDialog(true)}
            startIcon={<UploadFileIcon />}
            disabled={loading}
          >
            Upload Sitemap
          </Button>
        </div>
      </div>

      <TableContainer component={Paper} className="sitemap-table-container">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell className="table-header">Source File</TableCell>
              <TableCell className="table-header">Location URL</TableCell>
              {/* <TableCell className="table-header">Change Frequency</TableCell> */}
              <TableCell className="table-header">Last Modified</TableCell>
              {/* <TableCell className="table-header">Priority</TableCell> */}
              <TableCell className="table-header">Updated At</TableCell>
              <TableCell className="table-header">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading && sitemaps.length === 0 ? (
              <TableRow>
                <TableCell colSpan={7} align="center" className="no-data">
                  <CircularProgress size={40} />
                  <div style={{ marginTop: 10 }}>Loading sitemaps...</div>
                </TableCell>
              </TableRow>
            ) : sitemaps.length === 0 ? (
              <TableRow>
                <TableCell colSpan={7} align="center" className="no-data">
                  No sitemaps found. Please upload a sitemap file.
                </TableCell>
              </TableRow>
            ) : (
              sitemaps.map((sitemap) => (
                <TableRow key={sitemap._id} >
                  <TableCell className="sitemap-name">
                    {sitemap.sourceFile}
                  </TableCell>
                  <TableCell className="sitemap-loc">
                    <a
                      href={sitemap.loc}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {sitemap.sourceSitemap}
                    </a>
                  </TableCell>
                  {/* <TableCell>
                    <span className={`changefreq-badge ${sitemap.changefreq}`}>
                      {sitemap.changefreq}
                    </span>
                  </TableCell> */}
                  <TableCell>{sitemap.sourceSitemapLastmod || "N/A"}</TableCell>
                  {/* <TableCell>{sitemap.priority || "N/A"}</TableCell> */}
                  <TableCell>{formatDate(sitemap.updatedAt)}</TableCell>
                  <TableCell>
                    <IconButton
                      color="default"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleViewChildren(sitemap);
                      }}
                      size="small"
                      className="action-button"
                      disabled={loading}
                    >
                      <VisibilityIcon />
                    </IconButton>
                    <IconButton
                      color="primary"
                      onClick={() => handleEdit(sitemap)}
                      size="small"
                      className="action-button"
                      disabled={loading}
                    >
                      <EditIcon />
                    </IconButton>
                    <IconButton
                      color="error"
                      onClick={() => handleDeleteClick(sitemap)}
                      size="small"
                      className="action-button"
                      disabled={loading}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Upload Dialog */}
      <Dialog
        open={openUploadDialog}
        onClose={() => setOpenUploadDialog(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Upload Sitemap XML File</DialogTitle>
        <DialogContent>
          <div className="upload-dialog-content">
            <Button
              variant="outlined"
              component="label"
              fullWidth
              className="upload-button"
            >
              Choose XML File
              <input
                type="file"
                hidden
                accept=".xml,.xml.gz"
                onChange={handleFileUpload}
              />
            </Button>

            {selectedFile && (
              <div className="selected-file">
                <strong>Selected file:</strong> {selectedFile.name}
              </div>
            )}
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenUploadDialog(false)}>Cancel</Button>
          <Button
            onClick={handleUploadSubmit}
            variant="contained"
            color="primary"
            disabled={loading || !selectedFile}
          >
            {loading ? <CircularProgress size={24} /> : "Upload"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Edit Dialog */}
      <Dialog
        open={openEditDialog}
        onClose={() => setOpenEditDialog(false)}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>Edit Sitemap: {selectedSitemap?.sourceFile}</DialogTitle>
        <DialogContent>
          <div className="edit-dialog-content">
            <TextField
              label="Sitemap XML Content"
              multiline
              rows={20}
              value={editContent}
              onChange={(e) => setEditContent(e.target.value)}
              fullWidth
              variant="outlined"
              className="xml-editor"
              placeholder="Paste your XML content here..."
              disabled={loading}
            />
            <div className="xml-hint">
              <small>
                Note: Keep the XML structure valid. Only one URL entry is
                supported per update.
              </small>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenEditDialog(false)}>Cancel</Button>
          <Button
            onClick={handleUpdateSitemap}
            variant="contained"
            color="primary"
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} /> : "Update Sitemap"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={openDeleteDialog}
        onClose={() => setOpenDeleteDialog(false)}
      >
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this sitemap entry for{" "}
            <strong>{selectedSitemap?.loc}</strong>?
            <br />
            <br />
            This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDeleteDialog(false)}>Cancel</Button>
          <Button
            onClick={handleConfirmDelete}
            color="error"
            variant="contained"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default Sitemap;
